import { roleParamKey } from '@/composables/route'
import { Permission } from '@/lib/permissions/v1'

export enum AdminRolesRouteName {
    Index = 'admin.roles.index',
    Create = 'admin.roles.create',
    Edit = 'admin.roles.edit',
    Details = 'admin.roles.details',
    Permissions = 'admin.roles.permissions',
}

export default {
    path: 'roles',
    component: () => import('@/views/admin/Index.vue'),
    meta: {
        label: 'Roles',
        auth: true,
        breadcrumb: false,
    },
    children: [
        {
            path: '',
            name: AdminRolesRouteName.Index,
            component: () => import('@/views/admin/roles/Index.vue'),
            meta: {
                label: 'Roles',
                auth: true,
                location: 'sidebar',
                icon: 'fal fa-id-badge fa-fw',
                permission: Permission.RoleViewAny,
                group: 'main',
            },
            children: [
                {
                    path: 'create',
                    name: AdminRolesRouteName.Create,
                    component: () => import('@/views/admin/roles/Index.vue'),
                    meta: {
                        label: 'Create Role',
                        auth: true,
                        location: 'sidebar',
                        icon: 'fal fa-id-badge fa-fw',
                        permission: Permission.RoleCreate,
                        group: 'main',
                    },
                },
                {
                    path: `:${roleParamKey}/edit`,
                    name: AdminRolesRouteName.Edit,
                    component: () => import('@/views/admin/roles/Index.vue'),
                    meta: {
                        label: 'Edit Role',
                        auth: true,
                        location: 'sidebar',
                        icon: 'fal fa-id-badge fa-fw',
                        permission: Permission.RoleUpdate,
                        group: 'main',
                    },
                },
                {
                    path: `:${roleParamKey}/details`,
                    name: AdminRolesRouteName.Details,
                    component: () => import('@/views/admin/roles/Index.vue'),
                    meta: {
                        label: 'Edit Role',
                        auth: true,
                        location: 'sidebar',
                        icon: 'fal fa-id-badge fa-fw',
                        permission: Permission.RoleView,
                        group: 'main',
                    },
                },
                {
                    path: `:${roleParamKey}/permissions`,
                    name: AdminRolesRouteName.Permissions,
                    component: () => import('@/views/admin/roles/Index.vue'),
                    meta: {
                        label: 'Edit Permissions',
                        auth: true,
                        location: 'sidebar',
                        icon: 'fal fa-id-badge fa-fw',
                        permission: Permission.RoleView,
                        group: 'main',
                    },
                },
            ],
        },
    ],
}
